<template>
  <div class="loader"/>
</template>